import { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { convertFieldsToDates } from '@ais-ui/utils';
import { getReplayRange } from './getReplayRange';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';

interface ReplayRange {
  startDatetime: Date;
  endDatetime: Date;
}

export const useReplayRange = (): UseQueryResult<ReplayRange> => {
  const { replaySession } = useSession();

  return useQuery({
    queryKey: ['replayRange'],
    queryFn: async () => {
      if (!replaySession) {
        throw new Error('replaySession is not defined.');
      }

      const result = await getReplayRange(replaySession);

      if (result) {
        convertFieldsToDates(result, ['endTime', 'startTime']);
      }

      return { startDatetime: result.startTime, endDatetime: result.endTime };
    },
  }, 'replay:range');
};
